import type { SlideProps } from "@/engine/app/offsite-config";

const TILES = [
  {
    eyebrow: "24 / 7",
    title: "Antworten auf die häufigsten 5 Fragen.",
    text: "Ihr bekommt nur die komplexen Fälle.",
  },
  {
    eyebrow: "Online",
    title: "Chatbot — [Standardfrage] → [Antwort]",
    text: "Routine-Dialoge laufen ohne euch durch.",
  },
];

export function Slide11Chatbot(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">KI im Kundenservice</div>
        <h1 className="deck-title rise rise-2">
          Chatbot für <br />
          <span className="accent">Standardfragen</span>
        </h1>
      </header>

      <div className="chatbot-body">
        <div className="chatbot-questions rise rise-3">
          <div className="chatbot-bubble">„Wo finde ich meine Rechnung?"</div>
          <div className="chatbot-bubble">„Wie kann ich Strom von der SVO bekommen?"</div>
          <div className="chatbot-bubble">„Was ist der dynamische Tarif?"</div>
        </div>

        <div className="deck-cols2">
          {TILES.map((t, i) => (
            <div key={t.title} className={`col-card rise rise-${i + 4}`}>
              <div className="col-eyebrow">{t.eyebrow}</div>
              <h4>{t.title}</h4>
              <p>{t.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
